/**
 * All available single-page layout templates.
 * Each slot uses millimetre coordinates on an A4 landscape page (297×210mm).
 * y starts at 20mm (below the page header area).
 */

export const ALBUM_PAGE_TEMPLATES = [
  // ── 1 Slot ───────────────────────────────────────────────────────────────
  {
    id: 'SoloHero_1',
    name: 'Solo Hero',
    description: 'Single full-bleed hero covers the entire page',
    category: '1',
    slotCount: 1,
    slots: [
      { name: 'hero', x: 4, y: 20, width: 289, height: 186 },
    ],
  },
  {
    id: 'SoloPortrait_1',
    name: 'Solo Portrait',
    description: 'Centered tall portrait with side breathing room',
    category: '1',
    slotCount: 1,
    slots: [
      { name: 'hero-portrait', x: 78, y: 20, width: 141, height: 186 },
    ],
  },

  // ── 2 Slots ──────────────────────────────────────────────────────────────
  {
    id: 'DuoHalves_2',
    name: 'Duo Halves',
    description: 'Equal left/right halves, full height',
    category: '2',
    slotCount: 2,
    slots: [
      { name: 'left',  x: 4,   y: 20, width: 141, height: 186 },
      { name: 'right', x: 153, y: 20, width: 141, height: 186 },
    ],
  },
  {
    id: 'DuoPortrait_Inset_2',
    name: 'Duo Portrait Inset',
    description: 'Two tall portrait columns with gutter',
    category: '2',
    slotCount: 2,
    slots: [
      { name: 'left-portrait',  x: 34,  y: 20, width: 96, height: 186 },
      { name: 'right-portrait', x: 167, y: 20, width: 96, height: 186 },
    ],
  },
  {
    id: 'LandscapeStack_2',
    name: 'Landscape Stack (2)',
    description: 'Two full-width landscape strips stacked',
    category: '2',
    slotCount: 2,
    slots: [
      { name: 'top', x: 4, y: 20,  width: 289, height: 89 },
      { name: 'bot', x: 4, y: 117, width: 289, height: 89 },
    ],
  },

  // ── 3 Slots ──────────────────────────────────────────────────────────────
  {
    id: 'TrioBanner_3',
    name: 'Trio Banner',
    description: 'Wide banner top + two equal slots below',
    category: '3',
    slotCount: 3,
    slots: [
      { name: 'banner', x: 4,   y: 20,  width: 289, height: 70  },
      { name: 'bot-l',  x: 4,   y: 98,  width: 141, height: 108 },
      { name: 'bot-r',  x: 153, y: 98,  width: 141, height: 108 },
    ],
  },
  {
    id: 'TrioPortrait_3',
    name: 'Trio Portrait',
    description: 'Three equal portrait columns side by side',
    category: '3',
    slotCount: 3,
    slots: [
      { name: 'col-l', x: 4,   y: 20, width: 91, height: 186 },
      { name: 'col-m', x: 103, y: 20, width: 91, height: 186 },
      { name: 'col-r', x: 202, y: 20, width: 91, height: 186 },
    ],
  },
  {
    id: 'LandscapeStack_3',
    name: 'Landscape Stack (3)',
    description: 'Three full-width landscape strips stacked',
    category: '3',
    slotCount: 3,
    slots: [
      { name: 'top', x: 4, y: 20,  width: 289, height: 57 },
      { name: 'mid', x: 4, y: 85,  width: 289, height: 57 },
      { name: 'bot', x: 4, y: 149, width: 289, height: 57 },
    ],
  },
  {
    id: 'PortraitHero_Landscapes',
    name: 'Portrait Hero + Landscapes',
    description: 'Left tall portrait + 2 stacked landscape strips right',
    category: '3',
    slotCount: 3,
    slots: [
      { name: 'hero',   x: 4,   y: 20,  width: 126, height: 186 },
      { name: 'land-t', x: 138, y: 20,  width: 155, height: 89  },
      { name: 'land-b', x: 138, y: 117, width: 155, height: 89  },
    ],
  },

  // ── 4–5 Slots ────────────────────────────────────────────────────────────
  {
    id: 'FourPortrait_4',
    name: 'Four Portrait',
    description: 'Four equal portrait columns side by side',
    category: '4-5',
    slotCount: 4,
    slots: [
      { name: 'col-1', x: 4,   y: 20, width: 66, height: 186 },
      { name: 'col-2', x: 78,  y: 20, width: 66, height: 186 },
      { name: 'col-3', x: 153, y: 20, width: 66, height: 186 },
      { name: 'col-4', x: 227, y: 20, width: 66, height: 186 },
    ],
  },
  {
    id: 'ThreeStrip_Hero',
    name: 'Three Strips + Hero',
    description: 'Left: 3 horizontal strips. Right: large hero',
    category: '4-5',
    slotCount: 4,
    slots: [
      { name: 'strip-top', x: 4,   y: 20,  width: 155, height: 50  },
      { name: 'strip-mid', x: 4,   y: 78,  width: 155, height: 70  },
      { name: 'strip-bot', x: 4,   y: 156, width: 155, height: 50  },
      { name: 'hero',      x: 167, y: 20,  width: 126, height: 186 },
    ],
  },
  {
    id: 'MagazineHero_Trio',
    name: 'Magazine Hero + Trio',
    description: 'Left large hero + 3 stacked images right',
    category: '4-5',
    slotCount: 4,
    slots: [
      { name: 'hero',    x: 4,   y: 20,  width: 155, height: 186 },
      { name: 'right-1', x: 167, y: 20,  width: 126, height: 57  },
      { name: 'right-2', x: 167, y: 85,  width: 126, height: 57  },
      { name: 'right-3', x: 167, y: 149, width: 126, height: 57  },
    ],
  },
  {
    id: 'TwoCol_Blocks',
    name: 'Two Column Blocks',
    description: 'Left portrait + center 2 squares + right hero',
    category: '4-5',
    slotCount: 4,
    slots: [
      { name: 'hero-left',  x: 4,   y: 20,  width: 96,  height: 186 },
      { name: 'mid-top',    x: 108, y: 20,  width: 51,  height: 89  },
      { name: 'mid-bot',    x: 108, y: 117, width: 51,  height: 89  },
      { name: 'hero-right', x: 167, y: 20,  width: 126, height: 186 },
    ],
  },
  {
    id: 'AsymGrid_SplitHero',
    name: 'Asymmetric Grid + Hero',
    description: 'Left: wide banner + 2 squares. Right: tall hero',
    category: '4-5',
    slotCount: 4,
    slots: [
      { name: 'banner',   x: 4,   y: 20,  width: 155, height: 79  },
      { name: 'sq-left',  x: 4,   y: 107, width: 74,  height: 99  },
      { name: 'sq-right', x: 86,  y: 107, width: 74,  height: 99  },
      { name: 'hero',     x: 167, y: 20,  width: 126, height: 186 },
    ],
  },
  {
    id: 'FivePortrait_5',
    name: 'Five Portrait',
    description: 'Five equal portrait columns',
    category: '4-5',
    slotCount: 5,
    slots: [
      { name: 'col-1', x: 4,   y: 20, width: 51, height: 186 },
      { name: 'col-2', x: 63,  y: 20, width: 51, height: 186 },
      { name: 'col-3', x: 123, y: 20, width: 51, height: 186 },
      { name: 'col-4', x: 182, y: 20, width: 51, height: 186 },
      { name: 'col-5', x: 242, y: 20, width: 51, height: 186 },
    ],
  },
  {
    id: 'Grid2x2_Hero',
    name: '2×2 Grid + Hero',
    description: 'Left 2×2 grid of 4 + right large hero',
    category: '4-5',
    slotCount: 5,
    slots: [
      { name: 'grid-tl', x: 4,   y: 20,  width: 75,  height: 89  },
      { name: 'grid-tr', x: 87,  y: 20,  width: 75,  height: 89  },
      { name: 'grid-bl', x: 4,   y: 117, width: 75,  height: 89  },
      { name: 'grid-br', x: 87,  y: 117, width: 75,  height: 89  },
      { name: 'hero',    x: 170, y: 20,  width: 123, height: 186 },
    ],
  },

  // ── 6+ Slots (Grids) ─────────────────────────────────────────────────────
  {
    id: 'SixGrid_2x3',
    name: '6-Grid (2×3)',
    description: '2 columns × 3 rows equal grid',
    category: '6+',
    slotCount: 6,
    slots: [
      { name: 'r1c1', x: 4,   y: 20,  width: 141, height: 57 },
      { name: 'r1c2', x: 153, y: 20,  width: 141, height: 57 },
      { name: 'r2c1', x: 4,   y: 85,  width: 141, height: 57 },
      { name: 'r2c2', x: 153, y: 85,  width: 141, height: 57 },
      { name: 'r3c1', x: 4,   y: 149, width: 141, height: 57 },
      { name: 'r3c2', x: 153, y: 149, width: 141, height: 57 },
    ],
  },
  {
    id: 'EightGrid_4x2',
    name: '8-Grid (4×2)',
    description: '4 columns × 2 rows equal grid',
    category: '6+',
    slotCount: 8,
    slots: [
      { name: 'r1c1', x: 4,   y: 20,  width: 66, height: 89 },
      { name: 'r1c2', x: 78,  y: 20,  width: 66, height: 89 },
      { name: 'r1c3', x: 153, y: 20,  width: 66, height: 89 },
      { name: 'r1c4', x: 227, y: 20,  width: 66, height: 89 },
      { name: 'r2c1', x: 4,   y: 117, width: 66, height: 89 },
      { name: 'r2c2', x: 78,  y: 117, width: 66, height: 89 },
      { name: 'r2c3', x: 153, y: 117, width: 66, height: 89 },
      { name: 'r2c4', x: 227, y: 117, width: 66, height: 89 },
    ],
  },
  {
    id: 'Grid3x3_Hero',
    name: '3×3 Grid + Hero',
    description: 'Left 3×3 grid of 9 + right large hero',
    category: '6+',
    slotCount: 10,
    slots: [
      { name: 'grid-1', x: 4,   y: 20,  width: 47,  height: 57  },
      { name: 'grid-2', x: 59,  y: 20,  width: 47,  height: 57  },
      { name: 'grid-3', x: 114, y: 20,  width: 47,  height: 57  },
      { name: 'grid-4', x: 4,   y: 85,  width: 47,  height: 57  },
      { name: 'grid-5', x: 59,  y: 85,  width: 47,  height: 57  },
      { name: 'grid-6', x: 114, y: 85,  width: 47,  height: 57  },
      { name: 'grid-7', x: 4,   y: 149, width: 47,  height: 57  },
      { name: 'grid-8', x: 59,  y: 149, width: 47,  height: 57  },
      { name: 'grid-9', x: 114, y: 149, width: 47,  height: 57  },
      { name: 'hero',   x: 169, y: 20,  width: 124, height: 186 },
    ],
  },
  {
    id: 'TwelveGrid_4x3',
    name: '12-Grid (4×3)',
    description: '4 columns × 3 rows dense grid',
    category: '6+',
    slotCount: 12,
    slots: [
      { name: 'cell-1',  x: 4,   y: 20,  width: 66, height: 57 },
      { name: 'cell-2',  x: 78,  y: 20,  width: 66, height: 57 },
      { name: 'cell-3',  x: 153, y: 20,  width: 66, height: 57 },
      { name: 'cell-4',  x: 227, y: 20,  width: 66, height: 57 },
      { name: 'cell-5',  x: 4,   y: 85,  width: 66, height: 57 },
      { name: 'cell-6',  x: 78,  y: 85,  width: 66, height: 57 },
      { name: 'cell-7',  x: 153, y: 85,  width: 66, height: 57 },
      { name: 'cell-8',  x: 227, y: 85,  width: 66, height: 57 },
      { name: 'cell-9',  x: 4,   y: 149, width: 66, height: 57 },
      { name: 'cell-10', x: 78,  y: 149, width: 66, height: 57 },
      { name: 'cell-11', x: 153, y: 149, width: 66, height: 57 },
      { name: 'cell-12', x: 227, y: 149, width: 66, height: 57 },
    ],
  },
];

/** Tab categories for the Change Layout dialog. */
export const ALBUM_TEMPLATE_CATEGORIES = [
  { id: 'album', label: 'In Album',  description: 'Per-page layouts already used in this album' },
  { id: '1',     label: '1 Slot',    description: 'Single image layouts' },
  { id: '2',     label: '2 Slots',   description: '2-image layouts' },
  { id: '3',     label: '3 Slots',   description: '3-image layouts' },
  { id: '4-5',   label: '4–5 Slots', description: '4 or 5 image layouts' },
  { id: '6+',    label: '6+ Slots',  description: 'Grid layouts with 6 or more images' },
];
